module.exports = __webpack_public_path__ + "static/media/hyderabad-dark.7ab8a07f.svg";